import { ClientMsgV4 } from '@star-snake/shared'

export function encodePingV4(clientMonoMs: number): ArrayBuffer {
  const buffer = new ArrayBuffer(5)
  const view = new DataView(buffer)
  view.setUint8(0, ClientMsgV4.PING_V3)
  view.setUint32(1, clientMonoMs >>> 0, true)
  return buffer
}

export function encodeChainResyncRequestV4(reason = 0, lastSeenServerTick = 0): ArrayBuffer {
  const buffer = new ArrayBuffer(6)
  const view = new DataView(buffer)
  view.setUint8(0, ClientMsgV4.CHAIN_RESYNC_REQUEST_V3)
  view.setUint8(1, reason & 0xFF)
  view.setUint32(2, lastSeenServerTick >>> 0, true)
  return buffer
}

export function encodeRespawnRequestV4(): ArrayBuffer {
  const buffer = new ArrayBuffer(1)
  const view = new DataView(buffer)
  view.setUint8(0, ClientMsgV4.RESPAWN_REQUEST_V3)
  return buffer
}
